export const API_PRECO_DA_HORA_ENDPOINT_KEY = 'api_preco_da_hora_endpoint'
